/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ComplianceStatusResource = {
    Invalid: 'INVALID',
    Pending: 'PENDING',
    Valid: 'VALID'
} as const;
export type ComplianceStatusResource = typeof ComplianceStatusResource[keyof typeof ComplianceStatusResource];


export function instanceOfComplianceStatusResource(value: any): boolean {
    for (const key in ComplianceStatusResource) {
        if (Object.prototype.hasOwnProperty.call(ComplianceStatusResource, key)) {
            // @ts-ignore
            if (ComplianceStatusResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ComplianceStatusResourceFromJSON(json: any): ComplianceStatusResource {
    return ComplianceStatusResourceFromJSONTyped(json, false);
}

export function ComplianceStatusResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceStatusResource {
    return json as ComplianceStatusResource;
}

export function ComplianceStatusResourceToJSON(value?: ComplianceStatusResource | null): any {
    return value as any;
}

